
const fetchData = ({requestFunc, responseFunc, url, dispatch}) => {
    dispatch(requestFunc());
    fetch(url)
        .then(response => response.json())
        .then(data => {
            dispatch(responseFunc({
                data: data
            }));
    })
};

export default fetchData;
